module.exports = __webpack_public_path__ + "static/media/c4.1f25f025.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/compliance/c4.png
// module id = 504
// module chunks = 0